import store from '@/store/Index.js';
import { buildAccessDeniedLocation } from '@/utilities/accessDeniedLocation.js';

const DISABLED_STATUSES = ['suspended', 'withdrawn', 'dismissed'];

export default async (to, from, next) => {
    // Skip check if already on the restricted page
    if (to.path === '/restricted') {
        return next();
    }

    const authUser = store.state.Auth.user;

    // Skip if no user (not authenticated)
    if (!authUser) {
        return next();
    }

    // Check if user has any disabling statuses
    // Statuses should be loaded via the API login response
    const hasDisabledStatus = authUser?.statuses?.some(status => DISABLED_STATUSES.includes(status.name));

    if (hasDisabledStatus) {
        // Preserve the intended destination so Access Denied can show the page reference
        // (e.g. "/" for home/dashboard right after login).
        return next(buildAccessDeniedLocation(to, from));
    }

    return next();
};
